define([
    "underscore",
    "backbone"
], function(_, Backbone) {
    return Backbone.Model.extend({
        url: "/rest_account/save_phone_email",

        validation: {
            phone: {
                required: false,
                pattern: '^[0-9()+ \-]+$'
            },
            email: {
                required: true,
                pattern: 'email'
            }
        }
    });
});
